import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPaidSettlementSummaryReport extends Layout {
    checkboxEmailSummaries: Checkbox;
    checkboxIncludeExpandedPay: Checkbox;
    checkboxPostedPayments: Checkbox;
    excludabletextboxPayees: ExcludableTextbox;
    labelDash: Label;
    sourcePaidSettlements: DataSource;
    switchCheckRange: Switch;
    textboxCheckRangeEnd: Textbox;
    textboxCheckRangeStart: Textbox;
    textboxDateRange: Textbox;
    textboxPayeeType: Textbox;
}
